import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=637e420c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637e420c')) {
      api.createRecord('637e420c', component.options)
    } else {
      api.reload('637e420c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=637e420c&", function () {
      api.rerender('637e420c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AnmJhTc5nBgO/JS/comp/IncreaseNumber.vue"
export default component.exports